import styled from 'styled-components';

import { Text, token, spaceMixin } from '@zillow/constellation';

const containerMaxWidth = '537px';
const featureListMaxWidth = '370px';
const iconSize = '44px';

export const StyledBodyContainer = styled.div`
    max-width: ${containerMaxWidth};
    margin: 0 auto;
    padding: ${spaceMixin('xs')};
`;

export const StyledCenterText = styled(Text)`
    text-align: center;
`;

export const StyledDivider = styled.div`
    width: 140px;
    height: 2px;
    background: ${token('colors.yellow300')};
`;

export const StyledFeatureList = styled.ul`
    margin: 0 auto;
    padding: 0;
    max-width: ${featureListMaxWidth};
    list-style: none;
`;

export const StyledListItem = styled.li`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: ${spaceMixin('xl')};

    :last-child {
        margin-bottom: 0;
    }
`;

export const StyledIcon = styled.div`
    margin-right: ${spaceMixin('md')};
    color: ${token('colors.brand')};

    [class^="Icon"] {
        width: ${iconSize};
        height: ${iconSize};
    }
`;
